import { createFileRoute, redirect } from '@tanstack/react-router'
import type { JSX } from 'react'

import { VerifyPhoneForm } from '@/components/auth/verify-phone-form'
import { getVerificationState } from '@/lib/auth/verification'

export const Route = createFileRoute('/_public/verify-phone')({
  beforeLoad: () => {
    const { token, step } = getVerificationState()
    if (!token) throw redirect({ to: '/login' })
    // No permitir acceder a verify-phone si email aún no fue verificado
    if (step === 'email') throw redirect({ to: '/verify-email' })
  },
  component: VerifyPhonePage,
})

function VerifyPhonePage(): JSX.Element {
  return <VerifyPhoneForm />
}
